import { FONT_SIZE, ICON_SIZE, COLOR, Icon as _Icon } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivMobileRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  padding-top: 16px;
`;

export const Button = styled.button`
  display: grid;
  place-items: center;
  grid-gap: 4px;
`;

export const ButtonPlayWithApplication = styled.button`
  display: grid;
  place-items: center;
  grid-gap: 4px;
`;

export const SpSpanLabel = styled.span`
  color: ${COLOR.GRAY500.code};
  /** TODO（kimura） : UI Library側で8pxを加える必要がある */
  font-size: ${FONT_SIZE.XXS - 2}px;
`;

export const SpIcon = styled(_Icon)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLOR.GRAY900.code};
  border-radius: 50%;
  /** TODO（kimura） : UI Library側で40pxを加える必要がある */
  width: ${ICON_SIZE.XXL.width + 8}px;
  /** TODO（kimura） : UI Library側で40pxを加える必要がある */
  height: ${ICON_SIZE.XXL.height + 8}px;

  > svg {
    width: ${ICON_SIZE.L.width}px;
    height: ${ICON_SIZE.L.height}px;
  }
`;
